"use strict";
/**
 * Commission Reconciliation — categories & classification data (hvp-backend#434)
 *
 * Cross-references what QVET SOLD against what was COMMISSIONED, for 4 categories.
 * Detection is by the SALE LINE's section/family (catalog_items is incomplete).
 *
 * @see resources/research/20260609-qvet-section-to-commission-mapping.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMMISSION_SERVICE_TO_CATEGORY = exports.SURGERY_FAMILIES = exports.SERVICIOS_MEDICOS_SECTION = exports.RECONCILIATION_CATEGORY_LABELS = exports.ReconciliationCategory = void 0;
// ─── Category ──────────────────────────────────────────────────────────────
/** The 4 commissionable categories the reconciliation tracks. */
var ReconciliationCategory;
(function (ReconciliationCategory) {
    ReconciliationCategory["consulta"] = "consulta";
    ReconciliationCategory["vacuna"] = "vacuna";
    ReconciliationCategory["cirugia"] = "cirugia";
    ReconciliationCategory["emergencia"] = "emergencia";
})(ReconciliationCategory || (exports.ReconciliationCategory = ReconciliationCategory = {}));
exports.RECONCILIATION_CATEGORY_LABELS = {
    [ReconciliationCategory.consulta]: "Consulta",
    [ReconciliationCategory.vacuna]: "Vacuna",
    [ReconciliationCategory.cirugia]: "Cirugía",
    [ReconciliationCategory.emergencia]: "Emergencia",
};
// ─── QVET sale classification (by section/family of the sale line) ───────────
/** QVET section that holds clinical services. */
exports.SERVICIOS_MEDICOS_SECTION = "SERVICIOS MEDICOS";
/** Surgical families within SERVICIOS MEDICOS (any of these → Cirugía). */
exports.SURGERY_FAMILIES = [
    "CIRUGIA DE TEJIDOS BLANDOS",
    "ASISTENCIA QUIRURGICA",
    "OFTALMOLOGIA",
    "ORTOPEDIA",
];
// ─── Commission service → category ───────────────────────────────────────────
/**
 * Maps a stored `commissionAllocations.services[].serviceName` to its category.
 * Service names not listed here are outside the reconciliation scope.
 */
exports.COMMISSION_SERVICE_TO_CATEGORY = {
    // Consulta (cualquier tipo)
    Consulta: ReconciliationCategory.consulta,
    Revisión: ReconciliationCategory.consulta,
    Especialista: ReconciliationCategory.consulta,
    "Revisión especialista": ReconciliationCategory.consulta,
    "Consulta no convencionales": ReconciliationCategory.consulta,
    // Vacuna
    Vacuna: ReconciliationCategory.vacuna,
    // Cirugía (cualquier tipo, incluye roles quirúrgicos)
    Cirugía: ReconciliationCategory.cirugia,
    Anestesista: ReconciliationCategory.cirugia,
    "Primer ayudante": ReconciliationCategory.cirugia,
    // Emergencia
    Emergencia: ReconciliationCategory.emergencia,
};
